const pluralize = (count, noun, suffix = 's') => `${count} ${noun}${count !== '1' ? suffix : ''}`;
export default pluralize;
